<div class="detail-card">
  <ul class="detail-card-list">
    @if (extraFill()) {
      <li class="detail-card-item" attr.data-label="{{ 'DETAIL_CARD_COMPONENT.NAME' | translate }}">
        {{ $safeNavigationMigration(site()?.name) | infoDisplay }}
      </li>
      <li class="detail-card-item" attr.data-label="{{ 'DETAIL_CARD_COMPONENT.ENTITY' | translate }}">
        {{ $safeNavigationMigration(site()?.entity.name) | infoDisplay }}
      </li>
    }
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.ID' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(site()?.customerNumber) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.TYPE' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(site()?.type) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.ADDRESS_1' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(site()?.address.address1) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.ADDRESS_2' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(site()?.address.address2) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.CITY' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(site()?.address) | infoDisplay: 'brackets' : 'city' : 'zipCode' }}
    </li>
  </ul>
</div>
